import styled from 'styled-components'

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`

export const DropdownButton = styled.button<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.5rem;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
  }

  ${props => props.isOpen && `
    background-color: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.6);
  `}

  @media (max-width: 768px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }
`

export const DropdownContent = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(10, 30, 61, 0.15);
  min-width: 240px;
  z-index: 1000;
  animation: slideDown 0.2s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    min-width: 200px;
  }
`

export const MenuItem = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: #0a1e3d;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f8f9fa;
    padding-left: 1.25rem;
  }

  ${props => props.isActive && `
    background-color: #f0f4f8;
    border-left: 3px solid #ff8c42;
    padding-left: calc(1rem - 3px);
    font-weight: 600;
    color: #0a1e3d;
  `}

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.6rem 0.8rem;

    &:hover {
      padding-left: 1rem;
    }
  }
`

export const MenuIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1rem;
  flex-shrink: 0;
`

export const MenuLabel = styled.span`
  font-weight: 600;
`

export const Separator = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 0.5rem 0;
`
